import i18n, { getLanguage } from "@/lang"
import Cookies from 'js-cookie'
import axios from '@/axios'

//要设置的全局访问的state对象
const state = {
  language: getLanguage() || 'zh', // 中英文
  menuTitle: Cookies.get('menuTitle') || 'home', // 当前页面标题
  menuHighLight: Cookies.get('menuHighLight') || 'home', // 当前菜单key
  token: Cookies.get('token') || '', // 用户token
  account: Cookies.get('account') || '', // 用户account
  avatar: Cookies.get('avatar') || '', // 用户头像
  areaList: [], // 区域列表
  provinceList: [], // 省份列表
  cityList: [], // 城市列表
  resellerList: [], // 客户列表
  KeyDoorList: [], // iskeydoor列表
  courseClassList: [], // 品类列表
  roleList: [], // 角色列表
  statusList: [], // 状态列表
};

// 处理同步
const mutations = {
  languageEn(state) {
    state.language = 'en';
    i18n.locale = 'en';
    Cookies.set('language', 'en')
  },
  languageZh(state) {
    state.language = 'zh';
    i18n.locale = 'zh';
    Cookies.set('language', 'zh')
  },
  setMenuTitle(state, title) {
    state.menuTitle = title;
    Cookies.set('menuTitle', title)
  },
  setMenuHighLight(state, title) {
    state.menuHighLight = title;
    Cookies.set('menuHighLight', title)
  },
  setToken(state, token) {
    state.token = token;
    Cookies.set('token', token)
  },
  setAccount(state, account) {
    state.account = account;
    Cookies.set('account', account)
  },
  setAvatar(state, avatar) {
    state.avatar = avatar;
    Cookies.set('avatar', avatar)
  }
};

// 处理异步
const actions = {
  async getStoreArea({ state }, data = '', ) { // 获取地区
    let res = await axios.get("/pubServer/common/getRegionAuth/0", data);
    res = res.data;
    if (res.code === 200) state.areaList = res.data.regionList || [];
  },
  async getStoreProvince({ state }, data = '') { // 省份
    if (state.provinceList.length === 0) {
      let res = await axios.get("/pubServer/common/getProvince", data);
      res = res.data;
      if (res.code === 200) state.provinceList = res.data.provinceList || [];
    }
  },
  async getStoreCity({ state }, data = '') { // 城市
    if (state.cityList.length === 0) {
      let res = await axios.get("/pubServer/common/getCity", data);
      res = res.data;
      if (res.code === 200) state.cityList = res.data.cityList || [];
    }
  },
  async getStoreReselle({ state }, data = '') { // 客户
    if (state.resellerList.length === 0) {
      let res = await axios.get("/pubServer/common/getReseller", data);
      res = res.data;
      if (res.code === 200) state.resellerList = res.data.resellerList || [];
    }
  },
  async getStoreKeyDoor({ state }, data = '') { // iskeydoor
    if (state.KeyDoorList.length === 0) {
      let res = await axios.get("/pubServer/common/getIsKeyDoor", data);
      res = res.data;
      if (res.code === 200) state.KeyDoorList = res.data.resultInfos || [];
    }
  },
  async getStoreCourseClass({ state }, data = '') { // 品类
    if (state.courseClassList.length === 0) {
      let res = await axios.get("/pubServer/common/getCourseClass", data);
      res = res.data;
      if (res.code === 200) state.courseClassList = res.data.resultInfos || [];
    }
  },
  async getStoreRole({ state }, data = '') { // 角色
    if (state.roleList.length === 0) {
      let res = await axios.get("/pubServer/common/getRole", data);
      res = res.data;
      if (res.code === 200) state.roleList = res.data.roleList || [];
    }
  },
  async getStoreStatus({ state }, data = '') { // 状态
    if (state.statusList.length === 0) {
      let res = await axios.get("/pubServer/common/getStatus", data);
      res = res.data;
      if (res.code === 200) state.statusList = res.data.resultInfos || [];
    }
  }
};

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js